import React from 'react'
import ReactDOM from 'react-dom'
import App from './javascript/App'
import './stylesheets/Index.scss'

ReactDOM.render(<App />, document.getElementById('root'))
